module.exports = __webpack_public_path__ + "img/icircle.bedd8324.svg";